import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import './Tooltip.scss';

class Tooltip extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isVisible: props.isVisible,
        };
    }

    getTooltipContent(label, extraClassName) {
        return <div className={`Tooltip--content is-small ${extraClassName}`}>{label}</div>;
    }

    render() {
        const { label, className: tooltipExtraClass, children } = this.props;
        const { isVisible } = this.state;
        const newChildProps = {
            onMouseEnter: () => this.setState({ isVisible: true }),
            onMouseLeave: () => this.setState({ isVisible: false }),
        };
        return (
            <div className="Tooltip--wrapper">
                <ReactCSSTransitionGroup
                    className="Tooltip--content--animation-wrapper"
                    transitionName="Tooltip--content--animation"
                    transitionEnterTimeout={100}
                    transitionLeaveTimeout={50}
                >
                    {isVisible && this.getTooltipContent(label, tooltipExtraClass)}
                </ReactCSSTransitionGroup>
                {React.Children.map(children, (child) => React.cloneElement(child, newChildProps))}
            </div>
        );
    }
}

Tooltip.defaultProps = {
    className: '',
    isVisible: false,
};

Tooltip.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
    isVisible: PropTypes.bool,
};

Tooltip.displayName = 'Tooltip';

export default Tooltip;
